export interface AccountProjectBreakdown {
    project_id: number;
    earnings: number;
    expenses: number;
}

export function AccountProjectBreakdownFromJSON(json: any): AccountProjectBreakdown {
    return {
        project_id: json["project_id"],
        earnings: json["earnings"],
        expenses: json["expenses"],
    }
}


interface AccountRepoProjectFee {
    type: string;
    start_date: Date;
    charge: Array<number>;
    hourly: boolean;

    username: string;
    total: number;
    currency: string;
    activity: string;
}

function AccountRepoProjectFeeFromJSON(json: any): AccountRepoProjectFee {
    return {
        type: json["type"],
        start_date: new Date(json["start_date"]),
        charge: json["charge"],
        hourly: json["hourly"],
        username: json["username"],
        total: json["total"],
        currency: json["currency"],
        activity: json["activity"],
    }
}


interface AccountRepoProject {
    id: number;
    fees: Array<AccountRepoProjectFee>;
    monthly_minimum: number;
}

function AccountRepoProjectFromJSON(json: any): AccountRepoProject {
    return {
        id: json["id"],
        fees: (json["fees"] as Array<AccountRepoProjectFee>).map(AccountRepoProjectFeeFromJSON),
        monthly_minimum: json["monthly_minimum"],
    }
}


interface AccountRepoConfig {
    name: string;
    start_date: Date;
    projects: Array<AccountRepoProject>
}

function AccountRepoConfigFromJSON(json: any): AccountRepoConfig {
    return {
        name: json["name"],
        start_date: new Date(json["start_date"]),
        projects: (json["projects"] as Array<AccountRepoProject>).map(AccountRepoProjectFromJSON),
    }
}

export interface Account {
    id: number;
    custom_field_id: number;
    name: string;
    repo_config: AccountRepoConfig;
}

export function AccountFromJSON(json: any): Account {
    return {
        id: json["id"],
        custom_field_id: json["custom_field_id"],
        name: json["name"],
        repo_config: AccountRepoConfigFromJSON(json["repo_config"]),
    }
}
